class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.onCartUpdate();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate() {
    const cartJson = '/cart.js';
    fetch(cartJson)
      .then((response) => {
        return response.json();
      })
      .then(async (cart) => {
        var isCartEmpty = cart.items.length === 0;
        if (isCartEmpty) {
          sessionStorage.removeItem('gwtRemoved');
        }
        const gifts = window.gwpConfig?.gifts || [];
        const giftsInCart = cart.items.filter((item) => item.properties && item.properties._gwtFree);
        const oldGiftsInCart = giftsInCart.filter((item) => !gifts.find((gift) => gift.id === item.variant_id));
        const eligibleSpend = giftsInCart.reduce((acc, item) => acc - item.final_line_price, cart.total_price);
        for (const giftInCart of oldGiftsInCart) {
          await this.removeFreeProduct(giftInCart.key);
        }
        for (const gift of gifts) {
          const giftInCart = giftsInCart.find((item) => item.variant_id === gift.id);
          const minSpend = gift.minSpend;
          const ifCollectionProducts = gift.ifCollectionProducts;
          const ifProductsList = gift.ifProducts;
          const isProductRule = ifProductsList.length > 0 || ifCollectionProducts.length > 0;
          const eligibleProductInCart = cart.items.filter(item => (item.properties && !item.properties._gwtFree) && item.variant_id !== gift.id).some((item) => {
            let giftInBundle = false;
            if (item?.properties?._bundle_items) {
              giftInBundle = item.properties._bundle_items.split("|").map(bundleItemId => parseInt(bundleItemId)).includes(gift.id);
            }
            return (ifProductsList.includes(item.product_id) || ifCollectionProducts.includes(item.product_id)) && !giftInBundle;
          });
          const inEligible = (!isProductRule ? eligibleSpend < minSpend : !eligibleProductInCart);

          if (inEligible || !gift.customerEligible) {
            if (giftInCart) {
              await this.removeFreeProduct(giftInCart.key);
            }
          } else {
            if (!giftInCart && gift.available) {
              await this.addFreeProduct(gift.id, gift.customerGroup);
            }
          }
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  async removeFreeProduct(key) {
    const removeData = {
      id: key,
      quantity: 0,
    };
    return new Promise((resolve, reject) => {
      fetch('/cart/change.js', {
        body: JSON.stringify(removeData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: 'POST',
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          removeFromSessionStorage(gwtLocalCheck);
          window.dispatchEvent(new Event('freeGiftUpdate'));
        })
        .catch(function (err) {
          console.error(err);
          removeFromSessionStorage(gwtLocalCheck);
        })
        .finally(function () {
          resolve();
        });
    });
  }

  async addFreeProduct(productVariantId, customerGroup) {
    if (sessionStorage.getItem('gwtRemoved') || getFromSessionStorage(gwtLocalCheck)) {
      console.log('preventing duplicate call');
      return;
    }
    // else add the thing
    setInSessionStorage(gwtLocalCheck, 'true');
    const addData = {
      id: productVariantId,
      quantity: 1,
      properties: {
        _gwtFree: customerGroup || true,
      },
    };
    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: 'POST',
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          removeFromSessionStorage(gwtLocalCheck);
          window.dispatchEvent(new Event('freeGiftUpdate'));
        })
        .catch(function (err) {
          console.error(err);
          removeFromSessionStorage(gwtLocalCheck);
        })
        .finally(function () {
          resolve();
        });
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    // setTimeout(() => {
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    // this.open();
    // });
    const justLaunch = document.querySelector('.just-launched');
    if (justLaunch) {
      const innerDiv = this.querySelectorAll('.drawer__inner > div');
      var innerHeight = 0;
      innerDiv.forEach((element) => {
        if (element.classList.contains('just-launched')) {
          innerHeight += element.querySelector('.just-launched__body').clientHeight;
        } else {
          innerHeight += element.clientHeight;
        }
      });
      const cartItems = this.querySelector('cart-drawer-items');
      if (cartItems) {
        cartItems.style.maxHeight = 'calc( 100vh - ' + innerHeight + 'px )';
      }
    } else {
      const cartDrawer = document.querySelector('.cart-drawer');
      if (CartDrawer) {
        cartDrawer.classList.remove('cart-drawer-has-free-gift');
        cartDrawer.classList.remove('cart-drawer-has-just-launch');
      }
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
class CartSwipers extends CartItems {
  constructor() {
    super();
    this.swiper;
    this.breakpoint;
  }

  connectedCallback() {
    if (this.dataset.only) {
      this.breakpoint = window.matchMedia(this.dataset.only);
      this.checkBreakpoint();
      this.breakpoint.addEventListener('change', this.checkBreakpoint.bind(this));
      return;
    }

    this.buildSwiper();
  }

  checkBreakpoint() {
    if (this.breakpoint.matches) {
      this.buildSwiper();
    } else {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  buildSwiper() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 15,
      watchOverflow: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}

customElements.define('cart-swiper', CartSwipers);

const gwtLocalCheck = 'gwtAttemptAdd';
function getFromSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (err) {
    console.error('Could not get item from storage with key', key, err);
  }
}

function setInSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key.toString(), value.toString());
  } catch (err) {
    console.error('Could not set item in storage with key, value', key, value, err);
  }
}

function removeFromSessionStorage(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    console.error('Could not remove item from storage with key', key, err);
  }
}
